import {Inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {WindowRefService} from "../window-ref.service";
import {APP_CONFIG, AppConfig} from "../../config/app.config";
import {ActivatedRoute, Router} from "@angular/router";
import {AviaDetailsOffer} from "./interfaces/avia-details";
import {BehaviorSubject} from "rxjs";
import {DateMonthPipe} from "./pipes/date-month.pipe";

@Injectable({providedIn: 'root'})
export class BackBtnService {
  aviaOfferSub = new BehaviorSubject<AviaDetailsOffer | null>(null);
  aviaOffer$ = this.aviaOfferSub.asObservable();

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private titleService: Title,
    private window: WindowRefService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DateMonthPipe,
  ) {}

  setBackUrl(page, params = null) {
    let href = '';

    switch (page) {
      case 'aviaDetails':
        href = this.aviaListingUrl(params)
        break;
      default:
        href = '/new/findavia?from=avia-listing';
        break;
    }

    const backBtn = this.window.document.querySelector('#back-button');
    if (!backBtn) {
      return;
    }

    backBtn.setAttribute('href', `${href}`);
  }

  aviaListingUrl(params) {
    const queryParams = this.route.snapshot.queryParams;

    let queryString = '';
    if (!params || Object.keys(params).length === 0) {
      this.aviaOffer$.subscribe((offer: AviaDetailsOffer | null) => {
        if (offer) {
          const firstLeg = offer.legs[0];
          const secondLeg = offer.legs[1] ?? null;

          const childAges: number[] = offer.booking_info?.passengers?.child_ages ?? [];
          const childrenCount = childAges.length;
          let from = '';
          if (params?.from) {
            from = params.from;
          } else if (queryParams.from) {
            from = queryParams.from;
          }

          const offerParams = {
            departure: firstLeg.origin.airport.iata_code,
            destination: secondLeg ? secondLeg.origin.airport.iata_code : firstLeg.destination.airport.iata_code,
            dateFrom: this.datePipe.transform(firstLeg.departure_time, 'ymd'),
            dateTo: secondLeg ? this.datePipe.transform(secondLeg.arrival_time, 'ymd') : '',
            adults: String(offer.booking_info.passengers.adults),
            children: String(childrenCount),
            childAges: childAges.join(','),
            flyType: '',
            from: from
          }

          queryString = new URLSearchParams(offerParams).toString();

          this.setBackUrl('aviaDetails', queryString);
        }
      });
    } else {
      queryString = new URLSearchParams(params).toString();
      return '/new/search/avia?' + queryString;
    }
  }
}
